import React from "react";
import GroupLabel from "../GroupLabel";
import { useGroupMeta } from "../useGroupMeta";
import { GroupByTypeEnum } from "app/containers/Features/containers/Boards/types";
import { IGroupHeaderMeta, TicketGroup } from "../../../../Tickets/types";

interface Props {
  group: TicketGroup;
  groupBy: GroupByTypeEnum;
}

export default function HiddenGroupItem({ group, groupBy }: Props) {
  const meta = useGroupMeta(group._id);

  return <GroupLabel group={group} groupBy={groupBy} meta={meta as IGroupHeaderMeta} />;
}
